module.exports = __webpack_public_path__ + "static/media/huangzitao.8fd55fd9.png";